/* eslint-disable react-hooks/exhaustive-deps */
import { ReactNode, createContext, useEffect, useState } from "react";

import { transformData } from "@/utils/transformData";
import { attendanceMap } from "@/utils/mappings/attendance";
import { useAttendanceId } from "@/hooks/useAttendanceId";
import { useApi } from "@/hooks/useApi";

type AttendanceContextType = {
	attendance: Attendance;
};

type AttendanceContextProviderProps = {
	children: ReactNode;
};

export const AttendanceContext = createContext({} as AttendanceContextType);

export function AttendanceContextProvider({ children }: AttendanceContextProviderProps) {
	const [attendance, setAttendance] = useState<Attendance>({} as Attendance);
	const { attendanceId } = useAttendanceId();
	const { api } = useApi();

	async function fetchAttendance(attendanceId: number) {
		const { data } = await api.get(`fetch-attendance/${attendanceId}`, {
			params: {
				load_patient: 1,
				load_surgical_attendance: 1,
				load_latest_metrics: 1,
				load_surgical_team: 1,
				load_surgical_expertise: 1,
				load_active_hospitalization_permit: 1,
			},
		});

		const transformedData = transformData<Attendance>(data, attendanceMap);

		setAttendance(transformedData);
	}

	useEffect(() => {
		if (attendanceId) {
			fetchAttendance(attendanceId);
		}
	}, [attendanceId]);

	return (
		<AttendanceContext.Provider value={{ attendance }}>{children}</AttendanceContext.Provider>
	);
}
